import styled from 'styled-components';

export const Wrapper = styled.h1`
  color: ${({ theme }) => theme.palette.neutral.neutral100};
  font-size: ${({ theme }) => theme.fontSize[4]}px;
  margin: 0 0 1rem;
  font-weight: 600;
`;
